<template>
  <div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr class="panel-row">
            <th width="40px">&nbsp;</th>
            <th>
              API.expert Collections
              <a
                v-if="showAll"
                class="small"
                @click.prevent="showAll = false"
                @keyup.enter="showAll = false"
                >Show subscribed only</a
              >
              <a
                v-if="!showAll"
                class="small"
                @click.prevent="showAll = true"
                @keyup.enter="showAll = true"
                >Show all plans</a
              >
            </th>
            <th class="text-right">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="[catId, { name, price, children = null }] in categories"
            :key="catId"
            class="panel-row"
            @click.stop="toggle(catId)"
          >
            <td style="text-align: center">
              <LoadingAnim v-if="loadingId === catId" :no-text="true" />
              <template v-else>
                <a
                  v-if="hasPerm(catId)"
                  v-tooltip="'Remove collection'"
                  class="larger"
                  aria-label="Remove collection"
                  ><i class="glyphicon glyphicon-minus"
                /></a>
                <a
                  v-else-if="price === 0"
                  v-tooltip="'Add collection'"
                  class="larger"
                  aria-label="Add collection"
                  ><i class="glyphicon glyphicon-plus"
                /></a>
                <a
                  v-else
                  v-tooltip="'Coming soon!'"
                  disabled="true"
                  class="larger"
                  aria-label="Please visit API.expert to subscribe to this"
                  ><i class="glyphicon glyphicon-credit-card"
                /></a>
              </template>
            </td>
            <td>
              <span v-if="children" class="larger">
                {{ name }}
              </span>
              <a
                v-else
                target="_blank"
                rel="noopener noreferrer"
                :href="'https://www.api.expert/collection/' + catId"
              >
                <span class="larger">{{ name }}</span
                >{{ ' ' }}
                <small><i class="glyphicon glyphicon-new-window" /></small>
              </a>
              <template v-if="children">
                <template v-for="(child, childId) in children">
                  <br :key="'br-' + childId" />
                  <a
                    :key="'link-' + childId"
                    target="_blank"
                    rel="noopener noreferrer"
                    :href="'https://www.api.expert/collection/' + childId"
                  >
                    {{ child.name }}
                    <small><i class="glyphicon glyphicon-new-window" /></small>
                  </a>
                </template>
              </template>
            </td>
            <td class="text-right">
              <span v-if="hasPerm(catId)" class="larger"> SUBSCRIBED </span>
              <span v-else-if="price === 0" class="larger">
                FREE!
                <a class="btn btn-default" style="margin-left: 1em">Add</a>
              </span>
              <span v-else class="larger">
                First month FREE then ${{ price }} / month
                <a
                  :class="{ btn: true, 'btn-default': true, disabled: loadingId === catId }"
                  style="margin-left: 1em"
                  >Subscribe</a
                >
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="info-label">
        All API.expert users can monitor Search APIs and COVID-related APIs right now, for free.
        When you subscribe to API.expert Premium, you’ll also be able to follow 19 Enterprise
        Infrastructure vendors, 40 European banks, 5 major messaging services, and UK &amp; US
        Government APIs – all starting from just $10 per month.
      </p>
    </div>
    <div ref="apiExpertModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">API.expert subscription</h3>
          </div>
          <div class="modal-body">
            <p>We will now transfer you to API.expert to manage your subscriptions.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import $ from 'jquery';
import { call } from 'vuex-pathify';

const AUDIENCE = process.env.VUE_APP_AUTH0_AUDIENCE;
const API_EXPERT_CATEGORIES = {
  // 'cloud-service-providers': {
  //   name: 'Cloud Service Providers',
  //   price: 0,
  //   orgId: 'cloud',
  // },
  covid19: {
    name: 'COVID-19',
    price: 0,
    orgId: 'covid19',
  },
  'crypto-currency-exchanges': {
    name: 'Crypto Currency Exchanges',
    price: 0,
    orgId: 'exchanges',
  },
  'enterprise-it': {
    name: 'Enterprise IT',
    price: 0,
    orgId: 'corpinfra',
  },
  'enterprise-messaging': {
    name: 'Enterprise Messaging',
    price: 0,
    orgId: 'enterprisemessaging',
  },
  fintech: {
    name: 'Fintech',
    price: 0,
    orgId: 'fintech',
  },
  'ggv-capital-api-first-index': {
    name: 'GGV Capital: API First Index',
    price: 0,
    orgId: 'ggvcapitalapifirstindex',
  },
  'government-uk': {
    name: 'Government (UK)',
    price: 0,
    orgId: 'digitalgovernmentukgov',
  },
  'government-us': {
    name: 'Government (US)',
    price: 0,
    orgId: 'usgovernmentapis',
  },
  'messaging-cpaas-solutions': {
    name: 'Messaging (CPaaS Solutions)',
    price: 0,
    orgId: 'corporatemessaging',
  },
  'open-banking-psd2-sandboxes': {
    name: 'Open Banking PSD2 (Sandboxes)',
    price: 0,
    orgId: 'psd2institutions',
  },
  'open-banking-uk': {
    name: 'Open Banking UK Bundle',
    price: 0,
    // hidden: true,
    // groupParent: true,
    orgId: 'openbankingukproduction',
    children: {
      'open-banking-uk-open-data': {
        name: 'UK Open Banking (Open Data)',
        price: 0,
        group: 'open-banking-uk',
        orgId: 'ukbanks',
      },
      'open-banking-uk-production': {
        name: 'UK Open Banking (Production)',
        price: 0,
        group: 'open-banking-uk',
        orgId: 'openbankingukproduction',
        fractalLogo: true,
      },
      'open-banking-uk-sandboxes': {
        name: 'UK Open Banking (Sandboxes)',
        price: 0,
        group: 'open-banking-uk',
        orgId: 'openbankinguk',
      },
    },
  },
  search: {
    name: 'Search',
    price: 0,
    orgId: 'search',
  },
  'social-networks': {
    name: 'Social Networks',
    price: 0,
    orgId: 'social',
  },
  // weather: {
  //   name: 'Weather',
  //   price: 0,
  //   orgId: 'weather',
  // },

  // apimetrics: {
  //   name: 'APImetrics',
  //   price: 0,
  //   hidden: true,
  //   orgId: 'apimetricsqos',
  // },
  // travel: {
  //   name: 'Travel',
  //   price: 0,
  //   hidden: true,
  //   orgId: 'travel',
  // },
};

export default {
  name: 'ApiExpert',
  props: {
    filtered: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loadingId: null,
      API_EXPERT_CATEGORIES,
      wantShowAll: null,
    };
  },
  computed: {
    showAll: {
      get() {
        if (this.wantShowAll === null) {
          if (!this.userRoles.length) {
            return true;
          }
          return !this.filtered;
        }
        return this.wantShowAll;
      },
      set(val) {
        this.wantShowAll = val;
      },
    },
    userRoles() {
      if (!this.$auth.loading && this.$auth.isAuthenticated && this.$auth.user) {
        return this.$auth.user[`${AUDIENCE}/permissions`];
      }
      return [];
    },
    categories() {
      if (!this.showAll) {
        return Object.entries(this.API_EXPERT_CATEGORIES).filter(([key]) => this.hasPerm(key));
      }
      return Object.entries(this.API_EXPERT_CATEGORIES);
    },
  },
  watch: {
    filtered() {
      this.wantShowAll = null;
    },
  },
  mounted() {
    $(this.$refs.apiExpertModal).on('shown.bs.modal', () => {
      setTimeout(() => {
        window.location = 'https://www.api.expert/pricing/';
      }, 2000);
    });
  },
  methods: {
    hasPerm(id) {
      return this.userRoles.includes(`apiexpert_${id}`);
    },
    async toggle(id) {
      if (API_EXPERT_CATEGORIES[id].price === 0) {
        this.loadingId = id;
        try {
          if (this.hasPerm(id)) {
            await this.$fetcher.removeRole(`apiexpert_${id}`).catch((ex) => {
              console.log(ex);
            });
          } else {
            await this.$fetcher.addRole(`apiexpert_${id}`).catch((ex) => {
              console.log(ex);
            });
          }
          await this.$auth.getTokenSilently({ ignoreCache: true });
          await this.fetchAccountProjects(this.$route.meta);
          this.loadingId = null;
          // window.location.reload();
        } catch (ex) {
          console.log(ex);
          this.loadingId = null;
        }
      } else {
        this.loadingId = id;
        let success;
        try {
          ({ success } = await this.$fetcher.apiExpertSubscribe(`apiexpert_${id}`)).catch((ex) => {
            console.log(ex);
          });
        } catch (ex) {
          console.log(ex);
          success = false;
        }
        if (!success) {
          $(this.$refs.apiExpertModal).modal('show');
        } else {
          await this.$fetcher.apiExpertCheckSubs().catch((ex) => {
            console.log(ex);
          });
          await this.$auth.getTokenSilently({ ignoreCache: true });
          await this.fetchAccountProjects(this.$route.meta);
        }
        this.loadingId = null;
      }
    },
    fetchAccountProjects: call('account2/fetchAccountProjects'),
  },
};
</script>

<style scoped>
.text-normal {
  color: var(--light-main);
}
.larger {
  font-size: 2rem;
}
tr.panel-row {
  cursor: pointer;
}
tr.panel-row > td {
  vertical-align: middle;
}
</style>
